import styled from "styled-components";

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
`;

export const AvatarWrapper = styled.div`
	width: 80px;
	height: 80px;
	border: 7px solid #ffffff;
	border-radius: 50%;
	margin-right: 20px;

	@media (min-width: 769px) {
		width: 120px;
		min-width: 120px;
		height: 120px;
		min-height: 120px;
	}
`;

export const Name = styled.div`
	font-weight: 600;
	margin-bottom: 5px;
	font-size: 24px;
	text-transform: uppercase;
`;
